<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        <div class="form container px-2">
        <h5><b>H. OTHER RELEVANT INFORMATION</b></h5>

        <div class="mb-4">
            <div class="text-start mb-2">
                <b>
                    H.1 &nbsp; &nbsp;State any significant experience
                    gained during the reporting period:
                </b>
            </div>
            <div>
                <textarea v-model="experienceGained" type="text" class="form-control pb-0" id="exampleInputEmail1"
                    aria-describedby="emailHelp" rows="4" placeholder="e.g. Experience in teaching, research, human relations, as well as university and public administration"></textarea>
            </div>
        </div>

        <div class="mb-4">
            <div class="text-start mb-2">
                <b>
                    H.2 &nbsp; &nbsp;Describe any University activities (BCDEF & G) above
                    you think you excelled in during the reporting period:
                </b>
            </div>
            <div>
                <textarea v-model="serviceExcelledIn" rows="4" type="text" class="form-control pb-0" id="exampleInputEmail1"
                    aria-describedby="emailHelp" placeholder="e.g. Teaching, research, human relations, as well as university and public administration"></textarea>
            </div>
        </div>

        <div class="mb-4">
            <div class="text-start">
                <b>
                    H.3 &nbsp; &nbsp;Were there any University activities (BCDEF & G)
                    above you performed not very satisfactorily?
                </b>
            </div>
            <div>
                <textarea v-model="unsatisfactoryActivities" type="text" class="form-control pb-0" id="exampleInputEmail1"
                    aria-describedby="emailHelp" rows="4" placeholder="e.g. Teaching, research, human relations, as well as university and public administration"></textarea>
            </div>
        </div>

        <div class="mb-4">
            <div class="text-start">
                <b>
                    H.4 &nbsp; &nbsp;If so, please explain the reasons:
                </b>
            </div>
            <div>
                <textarea v-model="unsatisfactoryActivitiesReasons" rows="4" type="text" class="form-control pb-0"
                    id="exampleInputEmail1" aria-describedby="emailHelp"></textarea>
            </div>
        </div>

        <!--Award-->
        <div class="mb-4 text-start">
            <div class="mb-3">
                <b>
                    H.5 &nbsp; &nbsp;National and International Award:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#award"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=awards :type="'awards'" />
        </div>

        <!-- Award Modal -->
        <div class="modal fade" id="award" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">National and International Award</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 mx-4 text-start">
                            <label for="award" class="form-label me-3">Award Details:</label>
                            <textarea rows="5" v-model="award" type="text" class="form-control" id="award" placeholder="e.g. 2024 Distinguished Award of Excellence (3rd Category Distinguished Scholar), by the Faculty of Engineering, Rivers State University, Port Harcourt on 20th December, 2024."></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails()" type="button" class="btn btn-success"
                            data-bs-dismiss="modal">Add</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row-reverse my-5">
            <button @click="saveSection('next')" type="button" class="btn btn-success">Save & Continue</button>
            <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionH',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return { candidate: '',
            experienceGained: '',
            serviceExcelledIn: '',
            unsatisfactoryActivities: '',
            unsatisfactoryActivitiesReasons: '',
            award: '',
            awards: [],
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section H');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.awards.length; i++) {
                this.awards[i].editing = false
            }
        },
        
        setDetails(candidate) {
            this.candidate = candidate;
            this.experienceGained = candidate.experienceGained ? candidate.experienceGained : '';
            this.serviceExcelledIn = candidate.serviceExcelledIn ? candidate.serviceExcelledIn : '';
            this.unsatisfactoryActivities = candidate.unsatisfactoryActivities ? candidate.unsatisfactoryActivities : '';
            this.unsatisfactoryActivitiesReasons = candidate.unsatisfactoryActivitiesReasons ? candidate.unsatisfactoryActivitiesReasons : '';
            this.awards = candidate.academicStaff.awards ? candidate.academicStaff.awards : [];
        },
        async saveSection(page) {
            this.$emit('toggleLoader');

            var dataDetails = {
                experienceGained: this.experienceGained,
                serviceExcelledIn: this.serviceExcelledIn,
                unsatisfactoryActivities: this.unsatisfactoryActivities,
                unsatisfactoryActivitiesReasons: this.unsatisfactoryActivitiesReasons,
                awards: this.awards
            }

            const candidate = await DataService.saveData(dataDetails);

            if (candidate){
                this.setDetails(candidate)
                if (page == 'previous') {
                    this.$router.push('/sectiong')
                } else if (page == 'next') {
                    this.$router.push('/sectioni')
                }
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id, 'sectionH');

            if (candidate) { 
                if ((candidate.staffType == "Junior Non-academic") || (candidate.staffType == "Senior Non-academic")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/section1` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.setDetails(candidate)
            }
        
            this.$emit('toggleLoader');
        },
        joinDetails() {
            if (this.award) {
                this.awards.unshift({data: this.award});
                this.award = '';
            }
            this.key += 1
        },
    }
}
</script>